module.exports = __webpack_public_path__ + "static/media/watching.b23e0ede.svg";